'use client'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'

import { getFingerprint } from '@marketplace-web/domain/audit'
import { ClickableElement } from 'constants/tracking/clickable-elements'
import {
  landingPageEvent,
  HoVLandingPageEvent,
  HoVClosetSectionModel,
  HovClosetSectionProductCardModel,
} from '@marketplace-web/domain/marketing-landing-page-data'

import useSlider from '../../../../hooks/useSlider'
import HoVClosetSectionProductCard from './HoVClosetSectionProductCard'

type Props = { data: HoVClosetSectionModel }

const HoVClosetSection = ({ data: { title, productList, ctaText, ctaUrl } }: Props) => {
  const { track } = useTracking()
  const { itemRefs, handleOnTouchStart, handleOnTouchMove, handleOnTouchEnd, wrapperDivRef } =
    useSlider({ childData: productList })

  const handleOnCtaClick = async () =>
    track(
      landingPageEvent({
        event: HoVLandingPageEvent.ClosetCtaClick,
        target: ClickableElement.CtaRedirect,
        targetDetails: ctaUrl,
        deviceId: await getFingerprint(),
      }),
    )

  const renderSlider = (data: Array<HovClosetSectionProductCardModel>) => (
    <div
      className="hov__closet-section-cards-wrapper"
      ref={wrapperDivRef}
      onTouchMove={handleOnTouchMove}
      onTouchStart={handleOnTouchStart}
      onTouchEnd={handleOnTouchEnd}
    >
      {data.map((props, index) => (
        <div ref={itemRefs[index]} className="hov__closet-section-slider-wrapper-item" key={index}>
          <HoVClosetSectionProductCard
            key={index}
            {...props}
            testId={`closet-section-card-${index}`}
          />
        </div>
      ))}
    </div>
  )

  return (
    <section data-testid="hov-closet-section" className="hov__closet-section">
      <h2 className="hov__closet-section-title">{title}</h2>
      {renderSlider(productList)}
      <div className="hov__closet-section-cta-container">
        <a
          role="button"
          href={ctaUrl}
          className="hov__closet-section-cta"
          data-testid="hov-closet-section-cta"
          onClick={handleOnCtaClick}
        >
          {ctaText}
        </a>
      </div>
    </section>
  )
}

export default HoVClosetSection
